import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';

const Histogram = ({ data }) => {

    
    
  const timeSeriesWidth = window.innerWidth > 1350 ? 800 : 425;
  const timeSeriesHeight = window.innerWidth > 1350 ? 500 : 400;

  return (
    <Plot
      data={[
        {
          x: Object.values(data), // Extract values from the data object
          type: 'histogram',
          xbins: {
            start: Math.min(...Object.values(data)), // Set start based on the minimum value
            end: Math.max(...Object.values(data)),   // Set end based on the maximum value
            size: 5,                                  // Set bin size
          },
          marker: {
            color: '#EB0A1E',
          },
        },
      ]}
     
      layout={{
        width: timeSeriesWidth,
        height: timeSeriesHeight,
        // Adjust margin to move the heatmap to the top
        margin: {
          t: 25, // Adjust this value as needed
          l: 25,
          r: 25,
          b: 25
        },
        yaxis: {
          autorange: true,
          type: 'linear',
          automargin: true,
          title: 'Count'
        },
        title: 'Histogram of Speed',
        xaxis: { title: 'Speed' },
      }}
    />
  );
};

Histogram.propTypes = {
    data: PropTypes.any,
}

export default Histogram;
